import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { SplitPaymentFormComponent } from './split-payment-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ProvidersListModule } from '@shared/providers-list/providers-list.module';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PreventScrollDirective } from '@shared/prevent-scroll-directive/prevent-scroll.directive';
import { NgxMaskDirective } from 'ngx-mask';

@NgModule({
  declarations: [SplitPaymentFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ProvidersListModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    PreventScrollDirective,
    NgxMaskDirective,
  ],
  exports: [SplitPaymentFormComponent],
  providers: [CurrencyPipe],
})
export class SplitPaymentFormModule {}
